import { render, staticRenderFns } from "./editAdress.vue?vue&type=template&id=bd53d450&scoped=true&"
import script from "./editAdress.vue?vue&type=script&lang=js&"
export * from "./editAdress.vue?vue&type=script&lang=js&"
import style0 from "./editAdress.vue?vue&type=style&index=0&id=bd53d450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd53d450",
  null
  
)

export default component.exports